import { Route, Routes } from "react-router-dom";
import "./App.css";
import UpdateAddressWrapper from "./components";
import Home from "./Home";
import SessionWrapper from "./session";

function App() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/session" element={<SessionWrapper />} />
      <Route path="/orders/address_update" element={<UpdateAddressWrapper />} />
    </Routes>
  );
}

export default App;
